import React from 'react';
import { Platform, StyleSheet, Text } from 'react-native';
import colors from '../resources/colors';

const DashboardHeader = ({ children }) => <Text style={styles.text}>{children}</Text>;

const styles = StyleSheet.create({
  text: {
    fontFamily: 'FiraSans-Bold',
    fontSize: 20,
    fontWeight: Platform.OS === 'ios' ? 'bold' : 'normal',
    fontStyle: 'normal',
    lineHeight: 28,
    letterSpacing: 0.1,
    color: colors.primary,
  },
});

export default DashboardHeader;
